export default __webpack_public_path__ + "static/media/tapeOneMobile.5b919ecd.svg";